export const VALIDATION_RULE_GROUP_ENTRY_FORM_GENERAL = 'ENTRY_FORM_GENERAL';
export const VALIDATION_RULE_GROUP_ENTITIES = 'ENTITIES';
export const VALIDATION_RULE_GROUP_CSSF_DOCUMENTS = 'CSSF_DOCUMENTS';
export const VALIDATION_RULE_GROUP_LIST_OF_SECURITIES = 'LIST_OF_SECURITIES';
export const VALIDATION_RULE_GROUP_LEGISLATION = 'LEGISLATION';
export const VALIDATION_RULE_GROUP_CONTACTS = 'CONTACTS';
export const VALIDATION_RULE_GROUP_DOCUMENTS = 'DOCUMENTS';
export const VALIDATION_RULE_GROUP_NOTIFICATION = 'NOTIFICATION';
export const VALIDATION_RULE_GROUP_FINAL_TERMS = 'FINAL_TERMS';
